import type { CompositeFilterDescriptor } from "@progress/kendo-data-query";
import type { MultiColumnComboBoxColumn } from "@progress/kendo-react-dropdowns";

export const buildFilterDescriptor = (
  value: string,
  columns: MultiColumnComboBoxColumn[],
): CompositeFilterDescriptor => ({
  filters: columns.map((column) => ({
    field: column.field,
    ignoreCase: true,
    operator: "contains",
    value: value.trim(),
  })),
  logic: "or",
});
